import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _showAuthModalSubj$: Subject<unknown> = new Subject();
  private _isRedirectToPersonalPage$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  get showAuthModalSubj$(): Observable<unknown> {
    return this._showAuthModalSubj$.asObservable();
  }

  get isRedirectToPersonalPage$(): Observable<boolean> {
    return this._isRedirectToPersonalPage$.asObservable();
  }

  showAuthModal(): void {
    this._showAuthModalSubj$.next(null);
  }

  setRedirectToPersonalPage(isRedirect: boolean): void {
    this._isRedirectToPersonalPage$.next(isRedirect);
  }
}
